/**
 * Parses API risk score values. Returns null for missing, non-numeric, non-finite values,
 * and for 0 (aligned with Materiality / SOXCycleMappingReport: 0 means not assessed).
 */
function normalizeRiskScore(value) {
  if (value == null || value === '') return null;
  const parsed = Number.parseFloat(String(value));
  if (!Number.isFinite(parsed) || parsed === 0) return null;
  return parsed;
}

/**
 * Maps a numeric risk score to Module 1 buckets (LOW / MODERATE / HIGH).
 * Returns '' when not assessed (null, 0, or invalid).
 */
export function getCycleRiskLabel(riskScore) {
  const score = normalizeRiskScore(riskScore);
  if (score == null) return '';
  if (score <= 3.3) return 'LOW';
  if (score <= 6.6) return 'MODERATE';
  return 'HIGH';
}

/** Tailwind classes for cycle risk pills; keys match getCycleRiskLabel(). */
export function getCycleRiskLabelClasses(riskLabel) {
  if (riskLabel === 'HIGH') return 'bg-red-100 text-red-800 border-red-200';
  if (riskLabel === 'MODERATE') return 'bg-yellow-100 text-yellow-800 border-yellow-200';
  if (riskLabel === 'LOW') return 'bg-green-100 text-green-800 border-green-200';
  return 'bg-gray-100 text-gray-700 border-gray-200';
}

/**
 * Validates a Module 1 risk score for forms / API (same rules as Materiality risk edit modal).
 *
 * @param {unknown} raw — number or string from slider / input
 * @returns {{ ok: true, value: number } | { ok: false, message: string }}
 */
export function parseMaterialityRiskScoreForPayload(raw) {
  const score = Number.parseFloat(String(raw ?? '').trim());
  if (Number.isNaN(score) || score < 1.0 || score > 10.0) {
    return {
      ok: false,
      message: 'Please enter a valid score between 1.0 and 10.0'
    };
  }
  const value = Math.round(score * 10) / 10;
  return { ok: true, value };
}
